module.exports = __webpack_public_path__ + "img/icho_about_bg.f7c18392.png";